import { Input, DatePicker} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import OriginalEditedToggle from "./originalEditedToggle";
import TransactionsCsvExport from "./transactionsCsvExport";
import TransactionsTableDropdown from "./TransactionsTableDropdown";
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

const { RangePicker } = DatePicker;

// if completed, scheduled and canceled transactions don't
// have the same format (same json structure)
const TransactionTableFilters = (props) => {
	return (
  <Stack direction='row' spacing={1} alignItems='center'>
    <Box sx={{ flex: 'auto' }}>
      <Input placeholder="Search" prefix={<SearchOutlined />} onChange={props.handleSearch} />
    </Box>
    {props.type === "completed" && (
        <OriginalEditedToggle
          handleTransactionsKindChange={props.handleTransactionsKindChange}
          transactionsKind={props.transactionsKind}
          needsReviewCount={props.needsReviewCount}
        />
    )}
    <Box sx={{ flex: 'auto' }}>
      <RangePicker
        placeholder={["Start Date", "End Date"]}
        style={{ width: "100%" }}
        onChange={props.handleDateFilter}
      />
    </Box>
    <Box sx={{ flex: 'auto' }}>
      <TransactionsCsvExport
        filename={`transactions${props.bankAccountName
          ? "-" + props.bankAccountName.toLowerCase().replace(/ /g, "-")
          : ""
          }.csv`}
        exportedTransactions={props.type === "completed" ? null : props.exportdata}
        transactions={props.type === "completed" ? props.transactions : null}
      />
    </Box>
    {props.bankAccountSource && props.bankAccountSource !== "UN" && (
      <Box sx={{ flex: 0.1 }}>
        <TransactionsTableDropdown
          bankAccountName={props.bankAccountName}
          bankAccountSource={props.bankAccountSource}
          bankAccountId={props.bankAccountId}
          onRecalibrate={props.onRecalibrate}
        />
      </Box>
    )}
  </Stack>
	);
};

export default TransactionTableFilters;
